import { asyncRoutes, constRoutes } from '@/router'
import store from '@/store'

function hasPermission (route, pagePermissions, level) {
  if (level === 1) return true
  if (store.state.user.level === 'ROOT') return true
  if (route.path === 'kanban') return true

  return pagePermissions.has(route.path)
}

export function filterAsyncRoutes (routes, pagePermissions, level) {
  const res = []

  routes.forEach(route => {
    // 对象拷贝
    const tmp = { ...route }
    if (hasPermission(tmp, pagePermissions, level)) {
      if (tmp.children) {
        tmp.children = filterAsyncRoutes(tmp.children, pagePermissions, level + 1)
        // 如果没有儿子，那么父菜单也不要了
        if (tmp.children.length > 0) {
          res.push(tmp)
        }
      } else {
        // 叶子节点
        res.push(tmp)
      }
    }
  })

  return res
}

const state = {
  routes: constRoutes,
  addRoutes: []
}

const mutations = {
  SET_ROUTES: (state, routes) => {
    state.addRoutes = routes
    state.routes = constRoutes.concat(routes)
  },
  RESET: (state) => {
    state.routes = constRoutes
    state.addRoutes = []
  }
}

const actions = {
  generateRoutes ({ commit }, pagePermissions) {
    return new Promise(resolve => {
      const accessedRoutes = filterAsyncRoutes(asyncRoutes, pagePermissions, 1)
      commit('SET_ROUTES', accessedRoutes)
      resolve(accessedRoutes)
    })
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}
